import React from "react";
import { Button, Tag } from "antd";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ArrowLeftOutlined, PlayCircleOutlined, UserAddOutlined } from "@ant-design/icons";
import AppLayout from "../components/Layout";
import DataTable from "../components/DataTable";
import SearchBox from "../components/SearchBox";
import usePagedList from "../lib/usePagedList";
import { formatDate, SCENARIOS } from "../helper";

const scenarioTitle = (key) => (SCENARIOS.find((s) => s.key === key) || {}).title || key || "-";

const EventContacts = () => {
	const { id } = useParams();
	const navigate = useNavigate();
	const list = usePagedList(`events/${id}/students`);
	const eventName = list.rows.length && list.rows[0].event ? list.rows[0].event.name : null;

	const columns = [
		{ title: "Name", dataIndex: "name", key: "name" },
		{ title: "Email", dataIndex: "email", key: "email", render: (v) => v || "-" },
		{ title: "Phone", dataIndex: "phone_number", key: "phone", render: (v) => v || "-" },
		{ title: "Scenario", dataIndex: "event_type", key: "event_type", render: (v) => (v ? <Tag>{scenarioTitle(v)}</Tag> : "-") },
		{ title: "Added", dataIndex: "created_at", key: "created_at", render: formatDate },
		{
			title: "",
			key: "actions",
			align: "right",
			render: (row) => (
				<Button
					type="primary"
					size="small"
					icon={<PlayCircleOutlined />}
					onClick={() => navigate(`/start-experience?token=${encodeURIComponent(row.token)}&name=${encodeURIComponent(row.name)}`)}
				>
					Start experience
				</Button>
			),
		},
	];

	return (
		<AppLayout
			title={eventName ? `${eventName} — contacts` : "Event contacts"}
			subtitle="Contacts taking part in this event."
			actions={
				<>
					<SearchBox onSearch={list.onSearch} placeholder="Search contacts" />
					<Link to={`/event-mode?id=${id}${eventName ? `&name=${encodeURIComponent(eventName)}` : ""}`}>
						<Button type="primary" size="large" icon={<UserAddOutlined />}>
							Add contact
						</Button>
					</Link>
				</>
			}
		>
			<Link to="/events" style={{ display: "inline-block", marginBottom: 12 }}>
				<ArrowLeftOutlined /> All events
			</Link>
			<DataTable rows={list.rows} columns={columns} loading={list.loading} pagination={list.pagination} />
		</AppLayout>
	);
};

export default EventContacts;
